/* tslint:disable */
/* eslint-disable */
export enum ApplicationUserType {
  Employee = 'Employee',
  Contractor = 'Contractor',
  Consultative = 'Consultative',
  ConsultativeAndContractor = 'ConsultativeAndContractor'
}
